module.exports = __webpack_public_path__ + "img/account.6310dfde.svg";